import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../Components/misc/sideBar";
import SidePane from "../Components/misc/sidePane";
import MainMenu from "../Components/misc/mainMenu";

export const Home: React.FC = () => {
  const [selectedPage, setSelectedPage] = useState<number>(1);

  return (
    <div className="flex flex-col md:flex-row min-w-full items-start">
      {/* Sidebar */}
      <div className="flex justify-center w-full md:w-4/12 h-auto md:h-11/12">
        <SideBar
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
      </div>

      {/* Main Content */}
      <div className="flex flex-col justify-start items-center gap-5 w-full md:w-full md:basis-full">
        <div className="w-full h-screen bg-white p-6">
          <MainMenu
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
          />
          <div className="overflow-y-auto h-full">
            <Outlet />
          </div>
        </div>
      </div>

      {/* SidePane */}
      <div className="md:flex justify-center w-full md:w-4/12 h-auto md:h-screen hidden">
        <SidePane />
      </div>
    </div>
  );
};
